// src/components/EligibilityBox.js
import React from "react";
import "../styles/EligibilityBox.css";

export default function EligibilityBox({ text, emoji }) {
  // Add highlighting rules
  const highlighted = text
    .replace(
      /Aashiq-e-Rasool ﷺ/gi,
      '<strong class="highlight">Aashiq-e-Rasool ﷺ</strong>'
    )
    .replace(
      /Aashiq-e-Aala Hazrat/gi,
      '<strong class="highlight">Aashiq-e-Aala Hazrat</strong>'
    )
    .replace(
      /Pune Maharashtra/gi,
      '<strong class="highlight">Pune Maharashtra</strong>'
    )

  return (
    <div className="eligibility-card">
      <span className="eligibility-emoji">{emoji}</span>
      <p
        className="eligibility-text"
        dangerouslySetInnerHTML={{ __html: highlighted }}
      />
    </div>
  );
}